import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, Utensils } from "lucide-react";

const ROLE_LABEL = {
    garson: "Garson",
    mutfak: "Mutfak",
    kasa: "Kasa",
    admin: "Yönetici",
};

export default function AppHeader({ title, right }) {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate("/login");
    };

    return (
        <header className="sticky top-0 z-30 bg-white/85 backdrop-blur border-b border-[#E5E3D8]">
            <div className="max-w-[1600px] mx-auto px-6 md:px-8 h-16 flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-lg bg-[#D96C4A] text-white flex items-center justify-center">
                        <Utensils className="w-5 h-5" />
                    </div>
                    <div>
                        <div className="font-display text-lg font-semibold text-[#2C302E] leading-tight">
                            {title || "Sipariş Sistemi"}
                        </div>
                        <div className="text-xs text-[#59605B]">
                            {user ? `${user.name} · ${ROLE_LABEL[user.role] || user.role}` : ""}
                        </div>
                    </div>
                </div>
                <div className="flex items-center gap-3">
                    {right}
                    <button
                        onClick={handleLogout}
                        data-testid="logout-button"
                        className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-[#2C302E] bg-[#F3F1EB] hover:bg-[#E5E3D8] transition-colors"
                    >
                        <LogOut className="w-4 h-4" />
                        Çıkış
                    </button>
                </div>
            </div>
        </header>
    );
}
